import { EventDoc } from 'types/api/changes'
import { CurrentConvertedCalendars } from './google_events'
import { icloudPrefix } from './constants'

export function thirdPartyCalendarIdToPrimaryEmail(id: string): string {
  return (
    CurrentConvertedCalendars.find((calendar) => calendar.id === id)
      ?.primaryCalendarEmail || ''
  )
}

export function isIcloudEvent(event: EventDoc) {
  return event.GroupID?.includes(icloudPrefix)
}
